(function (window) {

    var translations = [];

    window.$t = function (key, params) {

        if (key === null || typeof key === 'undefined' || !key) {
            // We're not going to make API calls for invalid keys.
            return key;
        }

        var culture = calendarConfiguration.locale;

        if (!translations[key]) {

            translations[key] = [];
        }

        if (!(translations[key])[culture]) {

            ApiClient.getTranslations(culture, key).done(function (t) {

                (translations[key])[culture] = t.data[key];

            }).fail(function () {

                console.log('get translation for key ' + key + ' failed');

                (translations[key])[culture] = key;
            });
        }

        var translated = (translations[key])[culture];
        if (params) {
            translated.format.call(translated, params);
        }
        return translated;
    };
}(window));
